const RepublicOfTheCongoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112210)">
      <path
        d="M10.8413 37.785L25.5338 25.5344L37.7844 10.8418C35.8797 7.15058 32.8596 4.12879 29.1698 2.22168L14.4656 14.4663L2.22119 29.1703C4.12814 32.8602 7.14993 35.8803 10.8413 37.785Z"
        fill="#FFDA44"
      />
      <path
        d="M34.1428 34.1423C40.4527 27.8324 41.664 18.3561 37.7792 10.8291L10.8296 37.7787C18.3566 41.6634 27.833 40.4521 34.1428 34.1423Z"
        fill="#D80027"
      />
      <path
        d="M5.85727 5.85726C-0.452561 12.1671 -1.66381 21.6435 2.22079 29.1705L29.1705 2.22087C21.6435 -1.66389 12.1671 -0.452488 5.85727 5.85726Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112210">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default RepublicOfTheCongoSvg;
